import CashRegisterCreate from './CashRegisterCreate'
export {CashRegisterCreate}
export default CashRegisterCreate
